<template>
  <a-card :bordered="false">
    <a-row  type="flex" justify="center">
      <a-col :span="4" :style="{marginRight:'24px' } ">
         <a-input v-model="userInfo.uid" placeholder="用户id"/>
      </a-col>
      <a-col :span="2">
         <a-button type="primary" @click="handleQuery">查询</a-button>
      </a-col>
    </a-row>
    <div v-if="userInfo.isReal">
        <div class="row">
          <div class="label">昵称</div>
          <div class="content">{{userInfo.nickname}}</div>
        </div>
        <div class="row">
          <div class="label">头像</div>
          <div class="content">
             <img class="avatar" :src="userInfo.avatar" alt="avatar" width=128 height=128 />
          </div>
        </div>
        <div class="row">
          <div class="label">充值金额</div>
          <div class="content">
             <a-input  v-model.number="quantity" placeholder="充值金额"/>
          </div>
        </div>
        <div class="row">
          <div class="label"></div>
          <div class="content">
              <a-button type="primary" @click="handleRecharge">确认充值</a-button>
          </div>
        </div>
    </div>
  </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import {queryUserInfo,rechargeUser } from '@/api/user' 

export default {
  name: "UserRecordList",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      quantity:'',
      userInfo:{
        uid:'',
        nickname:'',
        avatar:'',
        isReal:false,
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      advanced: false,
      options:[],
      queryParam: {},
      // 表头
      columns: [
        {
          title: '用户ID',
          dataIndex: 'user_id'
        },
        {
          title: '用户昵称',
          dataIndex: 'user_name'
        },
        {
          title: '充值门店',
          dataIndex: 'branch_name'
        },
        {
          title: '充值数量',
          dataIndex: 'doll',
          sorter: true,
          needTotal: true
        },
        {
          title: '操作人',
          dataIndex: 'clerk_name'
        },
        {
          title: '时间',
          dataIndex: 'created'
        }
      ],
    }
  },
  created () {

  },
  methods: {
    handleQuery(){
      queryUserInfo({uid:this.userInfo.uid}).then(res => {
        const {uid,nickname,avatar,id} = res;
        this.userInfo = {
          id,
          uid,
          nickname,
          avatar,
          isReal:true,
        }
      },()=>{
         this.userInfo = {
          id:'',
          uid:this.userInfo.uid,
          nickname:'',
          avatar:'',
          isReal:false,
        }}
      )
    },
    handleRecharge(){
      if(!this.quantity){
        this.$message.error('充值数量不能为0');
        return;
      }
      const quantity = this.quantity;
      this.quantity = '';
      rechargeUser({id:this.userInfo.id,quantity}).then(res => {
         this.$message.success('操作成功')
      })
    }
  }
}
</script>
<style scoped>
.row{
  display: flex;
  padding-left: 100px;
  margin-bottom: 20px;
}
.label{
  width: 90px;
  font-weight: bold;
}
.content{
  width: 400px;
}

/* .avatar>img {
  width: 48px;
  height: 48px;
  display: block;
  border-radius: 50%;
} */
</style>

